import {computed, reactive, Ref, ref} from 'vue'

import storage from './storage'

type IDetectStore = {
  latestHtmlHash: string
  lastCheckedAt: number
}

const LOCAL_STORAGE_KEY = 'detect_info'
const DETECT_TIMEOUT = 15 * 60000 // 15 mins

class DetectCodeChangeService {
  store: IDetectStore = reactive({latestHtmlHash: null, lastCheckedAt: null}) as any
  currentHtmlHash: Ref<string> = ref(null) as any

  public changeDetected = computed(() => {
    return this.currentHtmlHash.value !== this.store.latestHtmlHash
  })

  constructor() {
    // Listen when local storage is updated from other tabs
    window.onstorage = ev => {
      if (ev.key !== LOCAL_STORAGE_KEY) return

      // When load multiple at the same times,
      // prevent other tabs to update latestHash earlier
      if (this.currentHtmlHash.value) this.updateStore(JSON.parse(ev.newValue as any))
    }
  }

  async refreshIndexHtmlHash(): Promise<void> {
    let _bool = false
    // Refresh html hash when load app
    // Or now exceeds 15 mins from lastCheckedAt
    if (!this.currentHtmlHash.value) {
      _bool = true
    } else {
      this.updateStore(JSON.parse(storage.getItem(LOCAL_STORAGE_KEY) as any))
      if (Date.now() - this.store.lastCheckedAt > DETECT_TIMEOUT) {
        _bool = true
      }
    }

    if (_bool) {
      await this.getIndexHtmlHash()
    }
  }

  async getIndexHtmlHash(): Promise<void> {
    const response = await fetch('/version.json')
    const version = await response.json()

    this.updateStore({
      latestHtmlHash: version.BUILD_TIME,
      lastCheckedAt: Date.now()
    })
    // Save to local storage to share between multiple tabs
    storage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(this.store))
    // Set currentHtmlHash when load app only
    if (!this.currentHtmlHash.value) {
      this.currentHtmlHash.value = version.BUILD_TIME
    }
  }

  updateStore(payload: Partial<IDetectStore>): void {
    Object.assign(this.store, payload)
  }
}

export const detectCodeChange = new DetectCodeChangeService()
